import { render, staticRenderFns } from "./Help-PSU.vue?vue&type=template&id=6b3aa31a&scoped=true&"
import script from "./Help-PSU.vue?vue&type=script&lang=js&"
export * from "./Help-PSU.vue?vue&type=script&lang=js&"
import style0 from "./Help-PSU.vue?vue&type=style&index=0&id=6b3aa31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3aa31a",
  null
  
)

export default component.exports